/*
 * @Author: jingyu.yang 
 * @Date: 2021-12-17 09:59:52 
 * @Last Modified by: jingyu.yang
 * @Last Modified time: 2022-04-13 11:56:36
 */
export default {
  inserted: function (el, binding) {
    let parentBox
    if (binding.modifiers.box && binding.value) {
      parentBox = binding.value.map(v => document.querySelector(v)).find(v => v)
    }
    let odiv = el;   //获取当前元素
    let flag = false;
    let needFilter = true
    let timer
    let elDialog = odiv.getElementsByClassName('el-dialog')[0]
    if (elDialog) {
      elDialog.getElementsByClassName('el-dialog__header')[0].style.cursor = 'move'
    } else {
      odiv.style.cursor = 'move'
      needFilter = false
      elDialog = odiv
    }
    let height
    let pBox
    odiv.onmousedown = (e) => {
      console.log(e.target.className, "e.target");
      if(e.target.className.indexOf("el-slider__button") !== -1){
        flag = false
        return;
      }
      if (needFilter) {
        if (e.target.className !== 'el-dialog__header' && e.target.className !== 'dialogTitle') {
          return
        }
      }
      if (parentBox) {
        height = odiv.offsetHeight
        pBox = parentBox.getClientRects()[0]
      }
      e.preventDefault();
      flag = true
      //算出鼠标相对元素的位置
      let disX = e.clientX - elDialog.offsetLeft;
      let disY = e.clientY - elDialog.offsetTop;
      let distYBig = document.body.clientHeight - elDialog.offsetHeight;
      let distXBig = document.body.clientWidth - elDialog.offsetWidth;
      //console.log(e.clientX, "clientX");
      //console.log(e.clientY, "clientY");
      //console.log(elDialog.offsetLeft,"offsetLeft");
      //console.log(elDialog.offsetTop, "offsetTop");
      odiv.onmousemove = (e) => {
        e.preventDefault();
        if (!flag) {
          return false
        }
        odiv.setAttribute("temp-move", true)
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;
        //console.log(left, "left");
        //console.log(top, "top");
        if (left < 0) {
          left = 0
        }
        if (top < 0) {
          top = 0
        }
        //console.log(e.target.className.indexOf("count-small"));
        if(e.target.className !=="count-small"){
          if(top > distYBig){
            top = distYBig;
          }
          if(left > distXBig){
            left = distXBig;
          }
        }
        if (parentBox && pBox) {
          if (top + height >= pBox.height) {
            top = pBox.height - height
          }
          if (left + odiv.offsetWidth >= pBox.width) {
            left = pBox.width - odiv.offsetWidth
          }
        }
       //console.log(left, "left终");
       //console.log(top, "top终");
        //移动当前元素
        elDialog.style.left = left + 'px';
        elDialog.style.top = top + 'px';
        elDialog.style.margin = "0px";
        elDialog.style.marginTop = "0px";
      };
      const up = (e) => {
        e.preventDefault();
        if (!flag) {
          return false
        }
        odiv.onmousemove = null;
        document.removeEventListener('mouseup', up, false);
        timer && clearTimeout(timer)
        timer = setTimeout(() => {
          odiv.removeAttribute("temp-move")
        }, 30)
      }
      document.addEventListener('mouseup', up, false);
    };
  }
}